import React, { useContext ,useState} from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Link, NavLink, useLocation } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import MenuIcon from "@material-ui/icons/Menu";
import CloseIcon from "@material-ui/icons/Close";
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";
import LoginButton from "../../Login/loginButton";
import { WebContext } from "../../../../Utility";
import Search from "../../navbarSearch";
import { NAVBAR_EXTERNAL_LINKS } from "../../../../Constants";
import { DesktopMenuDropdown } from "../mobileNavbar";
const useStyles = makeStyles((theme) => ({
  navbar: {
    height: 80,
    width: "100%",
    zIndex: 1,
    backgroundColor: 'transparent',
    position: "relative",
    boxShadow:
      "0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)",
  },
  navLink: {
    height: "inherit",
    color: theme.agentTheme.card.link_foreground,
  },
  navBarContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    height: "inherit",
    [theme.breakpoints.down("sm")]: {
      alignItems: "center",
    },
  },
  navBarLogo: {
    margin: "auto 0px",
    "& img": {
      width: "100%",
      objectFit: "contain",
    },
    [theme.breakpoints.down("sm")]: {
      maxWidth: "50%",
    },
  },
  navBarContent: {
    display: "flex",
    flexDirection: "row",
    marginLeft: theme.spacing(3),
  },
  navBarText: {
    padding: 5,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  navBarTextContainer: {
    marginRight: 20,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    height: "100%",
  },
  navIcon: {
    margin: "auto 0px",
    color: theme.agentTheme.primary.main,
    zIndex: 1,
  },
  navIconNonTransparent: {
     color: theme.agentTheme.primary.main,
  },
  navTextHover: {
    "&:hover": {
      height: 80,
      color: theme.agentTheme.primary.foreground,
      backgroundColor: theme.agentTheme.primary.main,
    },
    "&$activeNavItem": {
      height: 80,
      color: theme.agentTheme.primary.foreground,
      backgroundColor: theme.agentTheme.primary.main,
    },
    transition: "all 0.5s ease",
  },
  activeNavItem: {
    color: theme.agentTheme.primary.foreground,
    backgroundColor: theme.agentTheme.primary.main,
  },
  searchDiv: {
    margin: "auto 8px",
    width: "25%",
    [theme.breakpoints.down("sm")]: {
      width: "40%",
    },
  },
  activeMobileItem: {
    color: theme.agentTheme.primary.main,
  },
  loginButton: {
    marginTop: "20px",
    color: theme.agentTheme.primary.main,
    [theme.breakpoints.down("sm")]: {
      marginTop: "0px",
    },
  },
}));

export default (props) => {
  let {
    logo_url = "",
    contentArr = [],
    username = "",
    getLogoUrl,
    isMobile = false,
    toggleMenu: mobileNavBarOpen = false,
    memberProfile,
    onNavIconClick,
       handleCovidMenuClose,
    handleCovidMenuItemClick,
    loginItem,
  } = props || {};
  const classes = useStyles();
  const location = useLocation();
  const { isLoggedIn = false } = useContext(WebContext);
  const { website_modules: websiteModules = {} } = memberProfile || {};
  const { packages: isPackagesEnabled = true } = websiteModules || {};
  const [isLoginMenu, setIsLoginMenu] = useState(false);
     const [anchorEl, setAnchorEl] = useState(null);
       const [clickItem, setClickItem] = useState([]);
 const handleCovidMenuClick = (
    event,
    clickItemParam = [],
    islogin = false
  ) => {
    setIsLoginMenu(islogin);
    if (clickItemParam.length > 0) setClickItem(clickItemParam);
    if (anchorEl == null) setAnchorEl(event.currentTarget);
    else handleCovidMenuClose();
  };
  const getNavItem = () => {
    return (
      <>
        {contentArr.map((item) => {
          let showActive = false;
          if (location.pathname == item.link) showActive = true;
          else if (location.pathname == "/" && item.link == `/${username}`)
            showActive = true;
          else if (item.clickHandle) {
            item.clickItem.map((element) => {
              if (
                element.link == location.pathname ||
                element.link.pathname == location.pathname
              )
                showActive = true;
            });
          }
          if (mobileNavBarOpen) {
          } else {
            if (item.clickHandle) {
              return (
                <>
                  <div
                    className={`${classes.navTextHover} ${classes.navBarTextContainer
                      } ${showActive && classes.activeNavItem} ${classes.navLink
                      }`}
                    onClick={(e) => handleCovidMenuClick(e, item.clickItem)}
                  >
                    <Typography
                      variant="h6"
                      noWrap={true}
                      className={classes.navBarText}
                    >
                      {item.label} {item.dropdown && <KeyboardArrowDown />}
                    </Typography>
                  </div>
                </>
              );
            } else {
              const isExternalLink = NAVBAR_EXTERNAL_LINKS.includes(
                item.label.toLowerCase()
              );
              return isExternalLink ? (
                <a href={item.link} className={classes.navLink}>
                  <div
                    className={`${classes.navTextHover} ${classes.navBarTextContainer
                      } ${showActive && classes.activeNavItem}`}
                  >
                    <Typography
                      variant="h6"
                      noWrap={true}
                      className={classes.navBarText}
                    >
                      {item.label}
                    </Typography>
                  </div>
                </a>
              ) : (
                <NavLink
                  to={{
                    pathname: item.link,
                    hash: item.hash || "",
                    state: { memberProfileData: memberProfile },
                  }}
                  className={classes.navLink}
                >
                  <div
                    className={`${classes.navTextHover} ${classes.navBarTextContainer
                      } ${showActive && classes.activeNavItem}`}
                  >
                    <Typography
                      variant="h6"
                      noWrap={true}
                      className={classes.navBarText}
                    >
                      {item.label}
                    </Typography>
                  </div>
                </NavLink>
              );
            }
          }
        })}
      </>
    );
  };
  return (
    <div className={`${classes.navbar}`}>
      <Container maxWidth={false} className={classes.navBarContainer}>
        <div className={classes.navBarLogo}>
          {isMobile && (
            <div
              className={`${classes.navIcon} ${!mobileNavBarOpen && classes.navIconNonTransparent
                }`}
            >
              {!mobileNavBarOpen ? (
                <MenuIcon onClick={onNavIconClick} />
              ) : (
                <CloseIcon onClick={onNavIconClick} />
              )}
            </div>
          )}
          {!isMobile && logo_url && (
            <Link to={`/${username ? `${username}` : ""}`}>
              <img src={getLogoUrl(logo_url)} height="70" />
            </Link>
          )}
        </div>
        {isMobile && logo_url && (
          <Link to={`/${username ? `${username}` : ""}`}>
            <img src={getLogoUrl(logo_url)} height="70" />
          </Link>
        )}
        {!isMobile && (
          <div className={classes.navBarContent}>{getNavItem()}</div>
        )}

        {!isMobile && (
          <Box
            display={"flex"}
            width={"30%"}
            flexDirection={"row"}
            justifyContent={"flex-end"}
          >
            {isPackagesEnabled && (
              <div className={classes.searchDiv} style={{ width: "100%" }}>
                <Search type="NAVBAR_SEARCH_2" />
              </div>
            )}
            <Box
              onClick={(e) => isLoggedIn && handleCovidMenuClick(e, [], true)}
            >
              <LoginButton loginClass={classes.loginButton} />
            </Box>
          </Box>
        )}
        {isMobile && <LoginButton loginClass={classes.loginButton} />}
      </Container>
        {(isLoginMenu || clickItem.length > 0) && (
                    <DesktopMenuDropdown
                      anchorEl={anchorEl}
                      handleCovidMenuClose={handleCovidMenuClose}
                      loginMenu={isLoginMenu}
                      clickItem={isLoginMenu ? loginItem : clickItem}
                      handleCovidMenuItemClick={handleCovidMenuItemClick}
                    />
                  )}
    </div>
  );
};
